import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ProgramTemplateWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .program-template-wrapper {
    width: 100%;
  }
  .program-template {
    padding: 24px 16px;
    border-bottom: 1px dashed ${COLORS.primary_light_blue};
    ${responsive.MOBILE`
       padding: 16px 8px;
    `}
  }
  .program-template-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .delete-icon {
    margin-right: 8px;
  }
  .add-program-template {
    display: flex;
    justify-content: flex-end;
    padding: 32px 16px;
    background-color: ${COLORS.cirrus_black1};

    .btn-tertiary {
      height: 20px;
    }
  }

  .padding-bottom {
    padding-bottom: 16px;
  }
`;
